// extracted by mini-css-extract-plugin
export default {"contentContainer":"StyledDialogV2_contentContainer__T7seJ","iconContainer":"StyledDialogV2_iconContainer__eJwxd","closeIcon":"StyledDialogV2_closeIcon__o3Z0f"};